import { PledgeRadioWithCurrencyComponent } from "../util/amount/pledgeRadioWithCurrencyComponent";
import { DonationForm } from "../util/donation/donationForm";
import { StripePaymentElement } from "../util/stripe/stripePaymentElement";
import { getMeta } from "../util/helpers";
import { beforeSubmit, showErrorWithMessage } from "../util/payment/paymentForm";
import { getPaymentProcessorURL, redirectByResponse } from "../util/payment";
import { initializeLanguageSettings } from "../util/internationalization";
import { getRedirectUrlByStatusAndOutreach} from "../util/payment";
import isEmpty from 'lodash/isEmpty';

let undesignedDonation = '';
let pledgeMessage;
let captchaWidgetIdCC;
let captchaWidgetIdBank;

let defaultCurrency = getMeta("default_currency")?? "SGD";
AddMetaTag()
addOtherAmountStyle();

//mapping form elements
let formMap = {
  formSelector: "form#wf-form-Unchained-Singapore",
  paymentTabSelector: "a.two-btn-toggle--active--red",
  ccDonationTextSelector: "#donation-text",
  paypalDonationTextSelector: "#donation-text-paypal",
  customerTypeCheckboxId: "Give-CustomerType",
  companyInputWrapperId: "company-input-wrapper",
  companyInputId: "Give-Company",
  errorBlockSelector: ".w-form-fail:not(._w-form-fail-bank)",
  outreach: getMeta('outreach')||"FCBH-ASIA",
  defaultCurrency: getMeta('default_currency')||"SGD",
  defaultCountry: getMeta('default_country')||"SG",
  captcha: true,
  captchaId: "card-captcha"
};
let otherAmountElMap = {
    inputId: "other-quantity",
    suffixId: "other-qty-currency",
    initialValue: 30,
    sufixClass: "currency-sufix-2"
  };
let amountElMap = {
    currencySelectorEl: { selectCurrencyId: "Currency" },
    handleOtherAmountEl: otherAmountElMap,
    pledgeRadioEl: {
      handlesContainerSelector: "#amount-container",
      amountRadioNames: "Unchained-Singapore",
      elementValueIndex: '2',
      labelSelector: ".radio_value.w-form-label"
    }
  };
  //mapping form elements
  let pledgeFormMap = {
    formSelector: "form#wf-form-Unchained-Singapore-Bank",
    paymentTabSelector: "a.two-btn-toggle--active--red",
    ccDonationTextSelector: "#donation-text",
    paypalDonationTextSelector: "#donation-text-paypal",
    customerTypeCheckboxId: "Give-CustomerType",
    companyInputWrapperId: "company-input-wrapper",
    companyInputId: "Give-Company",
    errorBlockSelector: "._w-form-fail-bank.w-form-fail",
    outreach: getMeta('outreach')||"FCBH-ASIA",
    defaultCurrency: getMeta('default_currency')||"SGD",
    defaultCountry: getMeta('default_country')||"SG",
    captcha: true,
    captchaId: "bank-captcha"
  };

let pOtherAmountElMap = {
    inputId: "other-quantity-bank",
    suffixId: "other-qty-currency-bank",
    initialValue: 30,
    sufixClass: "currency-sufix-2"
  };
let pAmountElMap = {
    currencySelectorEl: { selectCurrencyId: "Currency-Bank" },
    handleOtherAmountEl: pOtherAmountElMap,
    pledgeRadioEl: {
      handlesContainerSelector: "#amount-container-bank",
      amountRadioNames: "Unchained-Singapore-Bank",
      elementValueIndex: '2',
      labelSelector: ".radio_value.w-form-label"
    }
  };

window.addEventListener("pageshow", () => {
  FCBH.docReady(async () => {
  const translations = await initializeLanguageSettings();
  onloadCallback();

  formMap = {...formMap, captchaWidgetId: captchaWidgetIdCC};
  pledgeFormMap = {...pledgeFormMap,  captchaWidgetId: captchaWidgetIdBank}

  const donationForm = new DonationForm(formMap, translations);
  const formPledge = new DonationForm(pledgeFormMap, translations);

    const formPayment = {
      firstNameElId: "Give-FirstName",
      lastNameElId: "Give-LastName",
      address1ElId: "Give-Address",
      address2ElId: "Give-Address-2",
      cityElId: "Give-city",
      stateElId: "Give-State",
      regionElId: "Give-Region",
      zipElId: "Give-Zip",
      countryElId: "Give-Country",
      emailElId: "Give-Email",
      phoneNumberElId: "Give-Phone-Number",
    };
    let stripePaymentElement = new StripePaymentElement(donationForm, formPayment);

    init(stripePaymentElement, donationForm, formPledge);

  });
  
});

function onloadCallback( ) {
  const bank = document.getElementById('bank-captcha');
  bank.classList.add("w-form-formrecaptcha","g-recaptcha","g-recaptcha-error","g-recaptcha-disabled");
  const card = document.getElementById('card-captcha');
  card.classList.add("w-form-formrecaptcha","g-recaptcha","g-recaptcha-error","g-recaptcha-disabled");

  const siteKey = "6LdZQtsrAAAAAKuAcVprVnSdCzuzf1FFMV2cFVcR";
    const options = {
      sitekey:  siteKey,
      theme: 'light'
     };
    // Renderiza o Captcha para o Form 1
    captchaWidgetIdBank = grecaptcha.render('bank-captcha',  options);
    captchaWidgetIdCC = grecaptcha.render('card-captcha', options);
}

function AddMetaTag() {
  const meta = document.createElement("meta");
    meta.name = "donationMessage";
    meta.content = "to give God's Word";
    document.head.append(meta);
  const rsMeta = document.createElement("meta");
    rsMeta.name = "returnSite";
    rsMeta.content = "fcbh_asia";
    document.head.append(rsMeta);

  let metaOutreach = document.querySelector("meta[name='outreach']");
  if (metaOutreach && metaOutreach.content) {
    metaOutreach.setAttribute("content", "FCBH_ASIA");
  }
}

function addOtherAmountStyle() {
    // 1. Crie o elemento <style>
    const styleElement = document.createElement('style');

    // 2. Defina as regras CSS como texto
    const cssRules = `
        .currency-sufix-2 {
          position: relative;
          top: -35px;
          color: #849cb5;
          left: 10px;
        }
      @media only screen and (min-width: 1920px) {
        .currency-sufix-2 {
          top: -24px;
        } 
      }

      @media only screen and (max-width: 991px) {
        .currency-sufix-2 {
          top: -35px;
        } 
      }
    `;
    
    styleElement.textContent = cssRules;

    document.head.appendChild(styleElement);
    
    document.getElementById('other-qty-currency')?.classList.add('currency-sufix-2');
    document.getElementById('other-qty-currency-bank')?.classList.add('currency-sufix-2');
    document.getElementById('other-qty-currency')?.classList.remove('currency-sufix');
    document.getElementById('other-qty-currency-bank')?.classList.remove('currency-sufix');
}

function init( stripePaymentElement, donationForm, formPledge) {
  const formCampaign = donationForm.formCampaign;

  const pledgeRadioWithCurrencyComponent = new PledgeRadioWithCurrencyComponent(donationForm, amountElMap, defaultCurrency, stripePaymentElement);
  const bankPledgeRadioWithCurrencyComponent = new PledgeRadioWithCurrencyComponent(formPledge, pAmountElMap, defaultCurrency);

  createFormCallbacks();

  function getAmount() {
    return donationForm.getStorage()?.amounts?.usdValue;
  }
  
  function getLocalAmount() {
    return donationForm.getStorage()?.amounts?.value;
  }

  function createFormCallbacks() {
    donationForm.onFormSubmit = async (event) => await onFormSubmit(event);
    donationForm.validateForm = async (event) => await validateForm(event);
   /* const pledgeBtn = document.querySelectorAll("input[type='submit']")[1];
   pledgeBtn.addEventListener("click", validatePledge);*/
    formPledge.onFormSubmit = (event) => validatePledge(event);
    formPledge.avalidateForm = (event) => validatePledge(event);
  }

  function mapFormFields() {

    const formattedDonationTotal = `${donationForm.getStorage()?.currency_code === "USD" ? "$" : `${donationForm.getStorage()?.currency_code} `
      }${donationForm.getStorage()?.amounts?.value}`;

    const pledgeMsg = isEmpty(donationForm.getStorage()?.pledge_message) ? "" : donationForm.getStorage()?.pledge_message;

    const formData = new FormData(donationForm.form);

    const spouse_first_name = formData.get("Spouse-First-Name")?.trim();
    const spouse_last_name = formData.get("Spouse-Last-Name")?.trim();
    let donationType;
    if (donationForm.donationType) {
      donationType = donationForm.donationType.toLowerCase() === 'monthly'? 'yes': 'no';
    }
    var hiddenFundCode = document.getElementById("project-fund-code")?.value;
    let fundCode = isEmpty( hiddenFundCode)? isEmpty( document.getElementById("project-fund-code")?.value)?
    "Vision2033-Q" : donationForm.getStorage()?.project_fund_code : hiddenFundCode;

    const formStruct = {
      cssid: "3u8kfk8rej7cvflqqkskura2nt",
      ...donationForm.getPrograms(),
      campaign: formCampaign.campaign,
      outreach: donationForm.outreach,
      return_site: isEmpty( getMeta('returnSite'))?"fcbh_asia": getMeta('returnSite'),
      undesignated_donation: "",
      amount: `$${getLocalAmount()}`,
      usd_amount: parseFloat(getAmount()).toFixed(2), //
      formatted_donation_total: formattedDonationTotal,
      currency_code: donationForm.getStorage()?.currency_code,
      recurring_donation: donationForm.getStorage()?.recurring_donation?? "no",
      first_name: `${formData.get("Give-FirstName")}`,
      last_name: formData.get("Give-LastName"),
      address_street: formData.get("Give-Address1"),
      address_street_2: formData.get("Give-Address2"),
      address_country: formData.get("Give-Country"),
      address_city: formData.get("Give-city"),
      address_region: formData.get("Give-Region"),
      address_state: formData.get("Give-Country") === "US" ? formData.get("Give-State") : formData.get("Give-Region"),
      address_zip: formData.get("Give-Zip"),
      phone: formData.get("Give-Phone-Number").replace(/\s/g, '').slice(-10),
      email: formData.get("Give-Email"),
      donation_message: formData.get("Give-Message"),
      name: `${formData.get("Give-FirstName")} ${formData.get("Give-LastName")}`,
      spouse_first_name,
      spouse_last_name,
      spouse_name: `${spouse_first_name} ${spouse_last_name}`,
      customer_type: formData.get('Give-CustomerType') ? 'Business' : 'Individual',
      customer_type_value: formData.get('Give-CustomerType'),
      company_name: formData.get('Give-Company').trim(),
      project_fund_code: fundCode,
      successful_url: `${window.location.origin}${getRedirectUrlByStatusAndOutreach("success", donationForm.outreach)}`,
      cancel_url: `${window.location.origin}${getRedirectUrlByStatusAndOutreach("error", donationForm.outreach)}`,
      ui_mode: 'custom',  
      pledge_message: pledgeMsg,
    };
    return formStruct;
  }

async function validateForm(event) {
    const formStruct = mapFormFields();
     const requiredFields =  [
      "amount",
      "first_name",
      "last_name",
      "address_street",
      "address_city",
      "address_country",
      "address_zip",
      "phone",
      "email",
    ];
    const fieldLabels = [
      "Amount",
      "First Name",
      "Last Name",
      "Address 1",
      "City",
      "Country",
      "Zip Code",
      "Phone Number",
      "Email",
      "Company Name or Organization Name",
    ];
    if (beforeSubmit(formStruct, donationForm, stripePaymentElement.minAmount, requiredFields, fieldLabels)) return true;
    event.preventDefault();
  }

  async function onFormSubmit(event) {
    const formStruct = mapFormFields();
    await stripePaymentElement.processStripePayment(formStruct);
    event.preventDefault();
  }

  function mapPledgeFormFields() {

    const formattedDonationTotal = `${donationForm.getStorage()?.currency_code === "USD" ? "$" : `${donationForm.getStorage()?.currency_code} `
      }${donationForm.getStorage()?.amounts?.value}`;

    const formData = new FormData(formPledge);
    pledgeMessage = formData.get("2023-Pledge")? `over the next ${formData.get("2023-Pledge")}` : "";

    const obj = {
      ...donationForm.getPrograms(),
      campaign: formCampaign.campaign,
      return_site: "fcbh",
      undesignated_donation: undesignedDonation,
      amount: `$${getAmount()}`,
      formatted_donation_total: formattedDonationTotal,
      currency_code: donationForm.getStorage()?.currency_code,
      first_name: `${formData.get("2023-Pledge-First-Name")}`,
      last_name: formData.get("2023-Pledge-Last-Name"),
      phone: formData.get("2023-Pledge-Phone-Number").replace(/\s/g, '').slice(-10),
      email: formData.get("2023-Pledge-Email"),
      pledge_message: pledgeMessage
    };
    return obj;
  }
  
  async function validatePledge(event) {
   /* const requireds = [
      "amount",
      "first_name",
      "last_name",
      "phone",
      "email",
      "pledge_message",
    ];
    const cleanNames = [
      "Amount",
      "First Name",
      "Last Name",
      "Phone Number",
      "Email",
      "I COMMIT TO GIVE MY GIFT OVER THE NEXT:",
    ];
    const formStruct = mapPledgeFormFields();
    if (beforeSubmit(formStruct, donationForm, requireds, cleanNames)) return true;*/
    event.preventDefault();
  }

  async function onPledgeSubmit(event) {
    let cresponse = grecaptcha.getResponse();
    const errorBlockEl = donationForm.errorBlockEl;
    const formStruct = mapPledgeFormFields();
    try {
      const errors = validatePledge(formStruct);
      if (errors.length > 0) {
        showErrorWithMessage(errorBlockEl, errors);
        return;
      }
  
      if (cresponse.length == 0) { 
        return;
      }
      const formToSend = new FormData();
      for (const key in formStruct) {
        formToSend.append(key, formStruct[key]);
      } 
  
      const response = await FCBH.axiosInstance.post(
        getPaymentProcessorURL("pledge"),
        formToSend
      );
      // We don't get the Location header due to cors, so we need to parse the response to check if its accepted or declined.
      redirectByResponse(response, donationForm.responseParams, donationForm.formCampaign.localForm);
  
    } catch (err) {
      console.error(err);
      const response = { data: err.responseText };
      if (response.data?.includes("status")) {
        redirectByResponse(response, donationForm.responseParams, donationForm.formCampaign.localForm);
      } else {
        showErrorWithMessage(errorBlockEl, "An error occurred while sending the form, please try again later.");
      }
    }
  }
}